import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getEventResources = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `event-resources`);
};
export const AddEventResources = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-resources/create`,
    obj,
    { headers }
  );
};

export const EditEventResources = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-resources/update`,
    obj,
    { headers }
  );
};

export const DeleteEventResources = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-resources/delete`,
    obj,
    { headers }
  );
};
